import CityPageTemplate from "../city-template/CityPageTemplate";
import { kenoshaConfig } from "./data";

export default function KenoshaWiPage() {
  return <CityPageTemplate config={kenoshaConfig} />;
}